<template>
  <!-- <div style="background-color: #fff; padding: 10px"> -->
  <!-- 搜索 -->
  <div ref="topDom" class="header-bar">
    <div class="bar-lef"></div>
    <div class="bar-rig">
      <div class="rig-one" @click="handleOpenModal">
        <a-button class="btn-primary">添加服务</a-button>
      </div>
    </div>
  </div>

  <!-- 表格 -->
  <a-table
      :columns="columns"
      :dataSource="dataSource"
      :loading="searchLoading"
      :pagination="false"
      :scroll="{ x: columns.length > 6 ? 1500 : 0, y: tableHeight }"
      class="table"
      size="small"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key == 'operation'">
        <a-button type="link" @click="handleEdit(record)">修改</a-button>
        <a-button danger type="link" @click="handleDel(record)">删除</a-button>
      </template>
    </template>
  </a-table>

  <!-- 弹窗 -->
  <a-modal
      v-model:visible="visibleAdd"
      :title="modalTitle"
      :width="600"
      @ok="addSave"
  >
    <a-form
        ref="formRef"
        :label-col="{ span: 4 }"
        :model="addForm"
        :rules="rules"
        hideRequiredMark
        labelAlign="left"
    >
      <a-form-item label="名称：" name="name">
        <a-input
            v-model:value="addForm.name"
            placeholder="请输入名称,如：保洁"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="单位：" name="unit">
        <a-input
            v-model:value="addForm.unit"
            placeholder="请输入单位，如：元/次"
            style="width: 100%"
        ></a-input>
      </a-form-item>
      <a-form-item label="费用：" name="price">
        <a-input
            v-model:value="addForm.price"
            placeholder="0或者空则不收取费用"
            style="width: 100%"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import {createVNode, nextTick, onMounted, reactive, toRefs, watch} from "vue";
import {serviceAdd, serviceDel, serviceEdit, serviceList,} from "@/api/api";
import {ExclamationCircleOutlined} from "@ant-design/icons-vue";
import useUtils from "@/hooks/useUtils.js"; //工具库
import store from "@/store/pms/landlord/index"; //VUEX
import {message, Modal} from "ant-design-vue";

export default {
  components: {},
  setup() {
    let {countTable, imgCut} = useUtils();

    // 搜索
    const search = reactive({
      topDom: "",
      searchLoading: false,
    });

    // 表格
    const table = reactive({
      tableHeight: "",
      dataSource: [],
      initColumns: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
        },
        {
          title: "服务名称",
          dataIndex: "name",
          key: "name",
        },
        {
          title: "费用",
          dataIndex: "price",
          key: "price",
        },
        {
          title: "单位",
          dataIndex: "unit",
          key: "unit",
        },
        {
          title: "操作",
          dataIndex: "operation",
          key: "operation",
          align: "center",
        },
      ],
      getTableData() {
        search.searchLoading = true;
        serviceList()
            .then((res) => {
              table.dataSource = res.data.list;
              search.searchLoading = false;
            })
            .catch(() => {
              search.searchLoading = false;
            });
      },
      handleDel(item) {
        Modal.confirm({
          title: `是否删除？`,
          icon: createVNode(ExclamationCircleOutlined),
          centered: true,
          onOk() {
            serviceDel({id: item.id}).then((res) => {
              message.success(res.msg);
              table.getTableData();
            });
          },
        });
      },
      handleEdit(item) {
        modal.modalTitle = "修改服务";
        nextTick(() => {
          modal.addForm.name = item.name;
          modal.addForm.unit = item.unit;
          modal.addForm.price = item.price;
          modal.addForm.id = item.id;
        });
        modal.visibleAdd = true;
      },
    });

    // 弹窗
    const modal = reactive({
      modalTitle: "",
      visibleAdd: false,
      handleOpenModal() {
        if (modal.formRef) {
          modal.formRef.resetFields();
        }
        modal.addForm.hids = [];
        modal.modalTitle = "添加服务";
        modal.visibleAdd = true;
      },
      formRef: "", //表单验证
      addForm: {
        name: "",
        unit: "元/次",
        price: "",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入单位",
            trigger: "blur",
          },
        ],
        price: [
          {
            required: false,
            trigger: "blur",
          },
        ],
      },
      // 保存
      isLoading: false,
      addSave() {
        if (modal.isLoading) {
          return;
        }
        if (modal.modalTitle == "添加服务") {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            serviceAdd(modal.addForm)
                .then((res) => {
                  message.success(res.msg);
                  nextTick(() => {
                    modal.isLoading = false;
                  });
                  modal.visibleAdd = false;
                  table.getTableData();
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          });
        } else {
          modal.formRef.validate().then(() => {
            modal.isLoading = true;
            serviceEdit(modal.addForm)
                .then((res) => {
                  message.success(res.msg);
                  nextTick(() => {
                    modal.isLoading = false;
                  });
                  modal.visibleAdd = false;
                  table.getTableData();
                })
                .catch(() => {
                  modal.isLoading = false;
                });
          });
        }
      },
    });

    watch(
        () => store.state.ContentHeight,
        () => {
          table.tableHeight = countTable(search.topDom) - 10;
        }
    );

    onMounted(() => {
      table.getTableData();
      table.tableHeight = countTable(search.topDom) - 10;
    });

    return {
      ...toRefs(search),
      ...toRefs(table),
      ...toRefs(modal),
      imgCut,
    };
  },
};
</script>

<style lang="scss">
.weixin {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .QR {
  }

  .info {
    font-weight: bold;
  }

  .tips {
    color: #f5a623;
    margin-top: 20px;
  }
}

.drawer {
  position: absolute;

  .header {
    height: 60px;
    border-bottom: 1px solid #f2f2f2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;

    .title {
    }

    .status {
    }
  }

  .content {
    padding: 20px;

    .title {
      padding: 10px 0;
    }

    .info {
      display: flex;
      padding: 7px 0;

      .lef {
        width: 100px;
      }

      .rig {
        width: 400px;
      }
    }
  }

  .operate {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0;
    width: 450px;
    height: 60px;
    border-top: 1px solid #f2f2f2;
    background-color: #fff;

    .lef {
    }

    .rig {
    }
  }
}

.fRed {
  color: red;
}

.bar {
  border-radius: 10px;
  padding: 2px 10px;
  height: 20px;
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-size: 12px;
}

.add-box {
  width: 100%;
  display: flex;
  // justify-content: space-between;
  padding: 0 10px;

  .add-lef {
    flex: 1;
    margin-right: 40px;
  }

  .add-rig {
    flex: 1;
  }
}

.checkbox {
  margin-left: 90px;
  margin-bottom: 24px;
}
</style>
